import { Bold, Flex } from './TremorCompat';
import { Panel, Text } from 'rsuite';

import { getControllerIconText } from '../utils/controllerIcons';

export const DisplayController = ({ register, borderOff }) => {
  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-2">
        <div
          style={{
            border: '1px solid',
            borderColor: 'lightgray',
            borderRadius: '5px',
            padding: '5px',
            boxShadow: '1px -1px 0 lightgray',
          }}
        >
          <img src={getControllerIconText(register.value).icon} alt="Controller Icon" width="30" height="30" />
        </div>
        <Text>
          <Bold>{getControllerIconText(register.value).Text}</Bold>
        </Text>
      </Flex>
    </Panel>
  );
};
